<template>
    <div class="step-box">
        <div class="step-head">第三步 上传作品海报</div>
        <div class="step-body">
            <div class="section-tip">
                <p>1. 上传的作品海报仅支持JPG/PNG/PDF格式，且文件大小不超过30MB。</p>
                <p>2. 请将作品海报命名为：选手姓名-作品名称，例如小迈-厉害的机器人.pdf。</p>
                <p>3. 投稿时间截止前，海报仍可修改并重新上传。</p>
            </div>
            <div class="upload">
                <div style="margin-bottom: 20px">
                    <div>
                        <div class="example-side">
                            <a-upload
                                    :beforeUpload="beforeFileUpload"
                                    :defaultFileList="defaultFileList"
                                    :multiple="true"
                                    :remove="handleFileRemove"
                                    @change="handleChange"
                                    :customRequest="handleCustomRequest"
                                    style="width: 60%"
                            >
                                <a href="javascript:" class="btn-upload" v-if="!defaultFileList.length">选择文件</a>
                            </a-upload>
                        </div>
                    </div>
                </div>
            </div>
            <div class="op-box">
                <a href="javascript:" class="btn secondary" @click="prev()">上一步</a>
                <a href="javascript:" class="btn primary" @click="contribute" :class="{'disabled': !defaultFileList.length}">投稿</a>
            </div>
        </div>
    </div>
</template>

<script>
    import {Upload, message} from 'ant-design-vue'
    import OSS from 'ali-oss'

    export default {
        name: "poster",
        components: {
            aUpload: Upload,
        },
        props: {
            userInfo: Object,
            gameInfo: Object,
            posterFile: Object,
            prev: Function,
        },
        data() {
            return {
                defaultFileList: [],
                ossClient: null,
                ossHost: '',
                filePath: '',
                posterFileInfo: null,
            }
        },
        created() {
            if(this.posterFile) {
                this.defaultFileList = [{
                    uid: this.posterFile.uid,
                    name: this.posterFile.name,
                    status: this.posterFile.status,
                    url: this.posterFile.url,
                }]
            }
            this.getOssToken()
        },
        methods: {
            getOssToken() {
                this.$axios.get('/oss/v1/ststoken/spark', {
                    headers: {
                        utoken: this.userInfo.utoken
                    }
                }).then((resp) => {
                    console.log(resp)
                    this.ossClient = new OSS({
                        accessKeyId: resp.data.data.accessKeyId,
                        accessKeySecret: resp.data.data.accessKeySecret,
                        stsToken: resp.data.data.stsToken,
                        bucket: resp.data.data.ossConfig.bucket,
                        region: resp.data.data.ossConfig.region,
                    })
                    this.ossHost = `https://${resp.data.data.ossConfig.ossHost}`
                    this.filePath = `${resp.data.data.ossConfig.prefixDir}${this.gameInfo.id}/${this.userInfo.uid}/`
                })
            },
            handleCustomRequest(file) {
                this.ossClient.put(`${this.filePath}${file.file.name}`, file.file).then(res => {
                    console.log(res)
                    file.onSuccess(res, file.file)
                })
            },
            handleChange(info) {
                console.log(info)
                const file = info.file
                const status = info.file.status
                if (status === 'done') {
                    console.log('图片上传成功...')
                    const res = file.response
                    const item = {
                        uid: res.name,
                        name: file.name,
                        status: 'done',
                        url: `${this.ossHost}/${res.name}`,
                    }
                    console.log(item)
                    this.posterFileInfo = Object.assign(item, {
                        fileName: res.name,
                        commitId: item.uid,
                    })
                    this.$emit('postFile', this.posterFileInfo)
                    this.defaultFileList.push(item)
                } else if (status === 'error') {
                    console.log(`${info.file.name} 文件上传失败`)
                }
            },
            handleFileRemove(file) {
                this.defaultFileList = this.defaultFileList.filter(item => {
                    if (file.name !== item.name) return item
                })
                console.log(this.defaultFileList)
                this.$emit('removePostFile')
            },
            beforeFileUpload(file) {
                console.log(file)
                return new Promise((resolve, reject) => {
                    const isJPG = file.type === 'image/jpeg'
                    const isPNG = file.type === 'image/png'
                    const isPDF = file.type === 'application/pdf'
                    if (!isJPG && !isPNG && !isPDF) {
                        message.error('文件大小或类型超出限制，请检查后重新上传。')
                        return reject(new Error('只支持上传jpg,png和pdf格式的文件'))
                    }
                    const isLt30M = file.size / 1024 / 1024 < 30
                    if (!isLt30M) {
                        message.error('文件大小或类型超出限制，请检查后重新上传。')
                        return reject(new Error('只支持上传30MB以内的文件'))
                    }
                    console.info('文件正在上传中...')
                    return resolve(true)
                })
            },
            contribute() {
                this.$emit('contribute', this.defaultFileList)
            }
        },
    }
</script>

<style lang="scss" scoped>
    .example-side {
        display: flex;
        flex-direction: row;
    }

    .btn-upload {
        display: block;
        height: 46px;
        line-height: 46px;
        font-size: 18px;
        color: #fff;
        padding: 0 34px;
        border-radius: 46px;
        background: #009ef6;
    }
</style>
